import apiClient from './config';

export interface FeedbackSubmitPayload {
  category: 'feedback' | 'bug' | 'suggestion';
  subject: string;
  message: string;
  page_url?: string;
}

export interface FeedbackSubmitResponse {
  message: string;
}

export async function submitFeedback(payload: FeedbackSubmitPayload): Promise<FeedbackSubmitResponse> {
  const { data } = await apiClient.post<FeedbackSubmitResponse>('/api/feedback', payload);
  return data;
}
